export default "__VITE_ASSET__DGCD1iL8__"